import VueJwtDecode from "vue-jwt-decode";
import store from './store/store';
import GuideService from './service/GuideService';
import BlumarJwtDecode from "./BlumarJwtDecode";


const guideService = new GuideService();

export const isTokenExpired = (token) => {
  var currentTime = new Date().getTime() / 1000;
  return currentTime < token.exp;
}

export const isValidToken = () => {
  const token = window.localStorage.getItem('token');
  return Boolean(token) && isTokenExpired(BlumarJwtDecode.decode(token));
}

export const removeToken = () => {
  window.localStorage.removeItem('token');
}

async function loadUser() {
  let {data} = await guideService.get();
  await store.dispatch('loadUserInfo', data);
}

const authenticationCheck = (then) => async (to, from, next) => {
  if (isValidToken()){
    await loadUser();
    then(next);
  } else {
    removeToken();
    next('/login');
  }
}

export let checkAuthentication = authenticationCheck(next => next());

export let checkAuthenticationAndMandatoryActions = authenticationCheck((next) => {
  if (store.state.user.acceptedTermsDate == null || !store.getters.hasAcceptedTerms)
    next('/aceitacao-do-manual-do-guia');
  else if(!store.state.user.hasSavedProfileInfo)
    next('/guide/me');
  else
    next();
});

export const checkNotAuthentication = (to, from, next) => {
  store.dispatch('hideAlert');
  if (!isValidToken()) {
    removeToken();
    next();
  }
  else
    next('/');
}



// WEBPACK FOOTER //
// ./src/auth-token.js